import { BaseApiModel } from './BaseApiModel';

export class VerifyUrlAssigned extends BaseApiModel {
  public link: string;
  public expired: boolean;
  public download: string;
}
